import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import AppContext from '@/context/AppContext'
import useCustomCopy from '@/hooks/useCustomCopy/useCustomCopy'

import { resolveCustomCopyKey, resolveDescription, resolveMethodIcon, resolveMethodName } from '../helpers'

const useRefundMessage = refundType => {
  const { t, i18n } = useTranslation()
  const { context } = useContext(AppContext)
  const refundMethod = context?.orderInfo?.allowed_refund_methods?.find(rm => rm.name === refundType)
  const isInstant = refundMethod?.is_instant || false
  const customDescription = useCustomCopy(resolveCustomCopyKey(refundType, isInstant))
  const title = isInstant ? 'Reembolso instantáneo' : 'Reembolso'

  return {
    title: t(title),
    description: customDescription || resolveDescription(refundType, isInstant, i18n.language),
    instant: isInstant,
    methodName: resolveMethodName(refundMethod, refundType, t),
    MethodIcon: resolveMethodIcon(refundType),
  }
}

export default useRefundMessage
